import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import useAdd from "../../api/useAdd";
import { useTranslation } from "react-i18next";

const AgentAdd = ({ open, onClose, token, onSuccess, agentType = "customer" }) => {
  const { t } = useTranslation();
  const { handleAddAsync, loading, resetForm } = useAdd(
    "shop/customers",
    token,
    t("agent.agentAddedSuccessfully", "Agent added successfully")
  );
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [address, setAddress] = useState("");

  const handleSubmit = async () => {
    if (!name.trim()) return;

    const formData = new FormData();
    formData.append("name", name.trim());
    formData.append("agent_type", agentType);
    formData.append("contact", number.trim());
    formData.append("address", address.trim());
    formData.append("email", "");
    formData.append("opening_balance", "0");

    await handleAddAsync(formData);
    setName("");
    setNumber("");
    setAddress("");
    onSuccess?.();
    onClose();
  };

  useEffect(() => {
    if (!resetForm) return;
    setName("");
    setNumber("");
    setAddress("");
  }, [resetForm, onClose, onSuccess]);

  const title = agentType === "supplier"
    ? t("agent.addSupplierTitle", "Add New Supplier")
    : t("agent.addAgentTitle", "Add New Customer");

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            autoFocus
            margin="dense"
            label={t("agent.name", "Name")}
            type="text"
            fullWidth
            required
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
          <TextField
            margin="dense"
            label={t("agent.number", "Phone Number")}
            type="text"
            fullWidth
            value={number}
            onChange={(event) => setNumber(event.target.value)}
          />
          <TextField
            margin="dense"
            label={t("agent.address", "Address")}
            type="text"
            fullWidth
            multiline
            rows={3}
            value={address}
            onChange={(event) => setAddress(event.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {t("agent.cancel", "Cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          sx={{ minWidth: 100 }}
          disabled={loading || !name.trim()}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : t("agent.submit", "Submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgentAdd;
